import { render, staticRenderFns } from "./noticesbonus.vue?vue&type=template&id=c52bc86a&scoped=true&"
import script from "./noticesbonus.vue?vue&type=script&lang=ts&"
export * from "./noticesbonus.vue?vue&type=script&lang=ts&"
import style0 from "./noticesbonus.vue?vue&type=style&index=0&id=c52bc86a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52bc86a",
  null
  
)

export default component.exports